export default __webpack_public_path__ + "static/media/4 Mubele en madera giratorio con vidrio .153840a0.jpeg";